import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);
gsap.defaults({ease: 'none'});

export default function homepageAnimations() {
    window.scrollTo(0, 0);

    // On scroll homepage animations
    const createOnScrollAnimations = function() {
        const selectors = ['.g-line--1', '.g-line--2' , '.g-line--3', '.g-line--4', '.g-line--5'];
        const goldLines = document.querySelectorAll(selectors.join(', '));

        if(goldLines.length === selectors.length) {
            const paths = [...document.querySelectorAll('.g-line path')];
            
            // Home top part
            const timeline1 = gsap.timeline({paused: true});
            timeline1.fromTo(".g-line--1 line", {strokeDashoffset: 540}, {strokeDashoffset: 0, duration: 1.5});
            timeline1.fromTo(".g-line--2 line", {strokeDashoffset: 140}, {strokeDashoffset: 0, duration: 1.5});
            timeline1.fromTo(".g-line--3 line", {strokeDashoffset: 345}, {strokeDashoffset: 0, duration: 1.5});
            
            // Home bottom part
            const timeline2 = gsap.timeline({paused: true});
            timeline2.fromTo(".g-line--4 path", {strokeDashoffset: 460}, {strokeDashoffset: 0, duration: 3.5});
            timeline2.fromTo(".g-line--5 path", {strokeDashoffset: 1620}, {strokeDashoffset: 0, delay: 2.5, duration: 5});

            const homeTopPartTimeline = gsap.timeline(
                {
                    scrollTrigger: {
                        trigger: ".g-line--1",
                        start: "top center-=40%",
                        onEnter: ({progress, direction, isActive}) => {
                            gsap.to(timeline1, {progress: 1, ease: 'expo.out', duration: 4.5});
                        }
                    }
                }
            );
            const homeBottomPartTimeline = gsap.timeline(
                {
                    scrollTrigger: {
                        trigger: ".g-line--4",
                        start: "top center-=20%",
                        onEnter: ({progress, direction, isActive}) => {
                            gsap.to(timeline2, {progress: 1, ease: 'expo.out', duration: 8});
                        }
                    }
                }
            );
        }
    }

    createOnScrollAnimations();
}; 